package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolToggleStatusRequest(
    @SerialName("is_active")
    val isActive: Boolean
)
